import React from 'react';
import { PRICE_AMOUNT, PRICE_CURRENCY } from '../data/salesContent';
type PriceBlockProps = {
  lead?: string;
  notes?: string[];
  className?: string;
};
export function PriceBlock({
  lead,
  notes = [],
  className = ''
}: PriceBlockProps) {
  return <div className={`text-center ${className}`} data-id="element-36" data-mp="2ct075vga83t3">
      {lead && <p className="font-display text-base font-bold uppercase tracking-[0.2em] text-carbon-400" data-id="element-37" data-mp="27x2qfo13wvfs">{lead}</p>}
      <p className="mt-1 font-display font-extrabold leading-none text-accent-400" data-id="element-38" data-mp="1k78fxd49fiyp">
        <span className="text-6xl md:text-7xl" data-id="element-39" data-mp="1g5mwta14u8g2">{PRICE_AMOUNT}</span>
        <span className="ml-2 text-3xl md:text-4xl" data-id="element-40" data-mp="1tw8gv22boofj">{PRICE_CURRENCY}</span>
      </p>
      {notes.length > 0 && <p className="mt-3 text-sm font-medium text-carbon-300 md:text-base" data-id="element-41" data-mp="1p5s3tj2ez4tp">{notes.join(' · ')}</p>}
    </div>;
}